import * as React from 'react';
/* eslint-disable-next-line */
import Svg, { SvgProps, G, Path, Ellipse } from "react-native-svg"


interface FormUserProps {
    props?: SvgProps;
    isActive: boolean
}


const SvgComponent = ({ props, isActive }:FormUserProps) => (
    <Svg
        xmlns='http://www.w3.org/2000/svg'
        width={23.114}
        height={25.753}
        {...props}
    >
        <G
            transform='translate(1 1)'
            fill='none'
            stroke={isActive ? '#fff' : '#b5c1c6'}
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={2}
        >
            <Path
                data-name='Caminho 83294'
                d='M21.114 23.753v-2.64a5.278 5.278 0 0 0-5.279-5.278H5.278A5.278 5.278 0 0 0 0 21.113v2.639'
            />
            <Ellipse
                data-name='Elipse 9416'
                cx={4.919}
                cy={5.466}
                rx={4.919}
                ry={5.466}
                transform='translate(5.466)'
            />
        </G>
    </Svg>
);

export default SvgComponent;
